module.exports = __webpack_public_path__ + "img/hotel-13.136fbc4c.jpeg";